<div *ngIf="(data$ | async) as d">
  <section class="my-5">

    <!--Card-->
    <div class="card card-cascade narrower">

      <!--Section: Chart-->
      <section>

        <!--Grid row-->
        <div class="row">

          <!--stats-->
          <div class="col-12 mr-0">

            <!--Card image-->
            <div class="view view-cascade gradient-card-header blue-gradient">
              <h2 class="h2-responsive mb-0">Standby Details for "{{d.day}}"</h2>
              <span>(as of 12/7/18 11:16)</span>
            </div>
            <!--/Card image-->

            <!--Card content-->
            <div class="card-body card-body-cascade pb-0">
              <!--Panel data-->
              <div class="row card-body ">

              </div>
              <!--/Panel data-->
            </div>
            <!--/.Card content-->

          </div>
          <!--stats-->

        </div>
        <!--Grid row-->

        <div class="row">
          <div div class="col-md-12 mr-0">

            <div>

            </div>

            <!-- Nav tabs -->
            <!-- <mdb-tabset [buttonClass]="'pills-primary white mb-2'"> -->
            <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-primary tabs-3'">
              <!--Panel 1-->
              <mdb-tab *ngFor="let group of d.groups" heading="{{group.name}}">
                <div class="row">
                  <div class="col-12">

                    <div *ngFor="let market of group.markets">
                      <h2 class="text-left">{{market.name}}</h2>
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col" *ngFor="let h of group.headers">{{h}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let ld of market.details" (click)="rowClickedFunc(group.name, group.keyFunc(ld))" style="cursor: pointer;">
                              <td *ngFor="let cd of group.columnsFunc(ld)">{{cd}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </div>
              </mdb-tab>
            </mdb-tabset>

          </div>
        </div>

      </section>
      <!--Section: Chart-->

    </div>
    <!--/.Card-->

  </section>
</div>